import styled from 'styled-components';
import { DOWN_ARROW, DOWN_ARROW_BLUE, IC_DOWN_ARROW_GREEN } from '../../../Assets/images';

const DropdownStyled = styled.div`
  display: flex;
  flex-direction: column;

  .form-label {
    padding: 0;
    margin: 0 0 8px 0;
    font-size: 13px !important;
    font-weight: 600;
    color: ${(props) => props.theme.text.medium} !important;
  }

  .dropdown {
    .dropdown-toggle {
      font-size: 17px;
      font-weight: 400;
      text-align: left;
      color: ${(props) => props.theme.text.dark};
      background: ${(props) => props.theme.color.white};
      border-color: ${(props) => props.theme.color.border};
      padding: 12px 35px 13px 15px;
      border-radius: 8px;

      &:focus {
        box-shadow: 0 0 0;
      }

      &::after {
        width: 11px;
        height: 8px;
        content: '';
        background: url(${DOWN_ARROW.src}) no-repeat 50% 50%;
        margin: 0;
        border: 0;
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        display: flex;
      }
      .user-name {
        display: block;
        font-weight: 600;
        font-size: 14px;
        margin-right: 5px;
        text-transform: capitalize;
      }
    }

    .dropdown-menu {
      min-width: 100%;
      padding: 0;

      .dropdown-item {
        font-size: 16px;
        font-weight: 600;
        padding: 13px 24px 14px 24px;
        display: flex;
        align-items: center;

        &:hover {
          color: ${(props) => props.theme.color.white};
          background: ${(props) => props.theme.blue.dark};
        }
      }

      .dropdown-menu-item {
        width: ${(props) => (props?.isHeaderDropdown !== 'userDropdown' ? 'auto' : '191px')};

        &:first-child {
          .dropdown-item {
            border-radius: 4px 4px 0 0;
          }
        }

        &:last-child {
          .dropdown-item {
            border-radius: 0 0 4px 4px;
          }
        }
      }
    }

    &.userDropdown {
      .dropdown-divider {
        margin: 0;
      }

      .dropdown-toggle {
        font-size: 14px;
        font-weight: 600;
        border: 0;
        background: transparent;
        padding: 0 20px 0 0;

        &::after {
          width: 10px;
          height: 10px;
          content: '';
          background: url(${DOWN_ARROW.src}) no-repeat 50% 4px / 9px;
          margin: 0;
          border: 0;
          position: absolute;
          top: 50%;
          right: 3px;
          transform: translateY(-50%);
          display: flex;
        }
      }
      .dropdown-menu {
        top: 14px !important;

        .dropdown-menu-item {
          .dropdown-item {
            padding: 9px 12px;
          }
          .text {
            font-size: 12px;
            font-weight: 600;
          }

          .ic {
            width: 18px;
            height: 18px;
            border-radius: 0;

            > div {
              width: 18px;
              height: 18px;
              position: relative !important;
            }
          }
        }

        &:before,
        &:after {
          content: '';
          width: 12px;
          height: 8px;
          position: absolute;
          border-top: 0;
        }
        &:after {
          top: -8px;
          right: 20px;
          border-bottom: 8px solid ${(props) => props.theme.color.white};
          border-right: 8px solid transparent;
          border-left: 8px solid transparent;
        }
        &:before {
          top: -10px;
          right: 19px;
          border-bottom: 9px solid ${(props) => props.theme.color.border};
          border-right: 9px solid transparent;
          border-left: 9px solid transparent;
        }
      }
    }

    &.plain {
      .dropdown-toggle {
        font-size: 13px;
        border: 0;
        background: transparent;
        padding: 0 20px 0 0;

        &::after {
          width: 10px;
          height: 10px;
          content: '';
          background: url(${DOWN_ARROW.src}) no-repeat 50% 50%;
          margin: 0;
          border: 0;
          position: absolute;
          top: 50%;
          right: 6px;
          transform: translateY(-50%);
          display: flex;
        }
      }
    }
  }

  .region-language-dropdown {
      .dropdown-item {
      }
    }

    .region {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: ${(props) => props.theme.text.darkest};
    }

    .language {
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      color: ${(props) => props.theme.colors.neutral.darkBlue['400']};
    }

  &.fullWidth {
    width: 100%;
    .dropdown {
      width: 100%;
      .dropdown-toggle {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .dropdown-menu {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        .dropdown-item {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }
    }
  }
  &.epharmacy {
    .dropdown {
      .dropdown-menu {
        .dropdown-item {
          border-bottom: 1px solid ${(props) => props.theme.color.border};
          &:hover {
            color: ${(props) => props.theme.color.green}!important;
            background: ${(props) => props.theme.grey.greyF4};
          }
          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }

  &.appointmentFilter {
    position: absolute;
    right: 24px;
    top: 15px;

    .dropdown {
      .dropdown-menu {
        min-width: 160px;
        border-color: ${(props) => props?.theme?.color?.borderLight};

        .dropdown-item {
          color: ${(props) => props?.theme?.text?.medium};
          font-size: 14px;
          padding: 7px 10px 8px 10px;

          &:hover {
            color: ${(props) => props?.theme?.color?.white};
            background: ${(props) => props?.theme?.blue?.dark};
          }

          &:first-child {
            border-radius: 6px 6px 0 0;
          }

          &:last-child {
            border-radius: 0 0 6px 6px;
          }

          &.active {
            color: ${(props) => props?.theme?.color?.white};
            background: ${(props) => props?.theme?.blue?.dark};
          }
        }
      }
      .dropdown-toggle {
        color: ${(props) => props?.theme?.blue?.dark};
        font-size: 14px;
        font-weight: 600;
        border-color: transparent;
        padding: 10px 25px 10px 15px;

        &:hover {
          border-color: transparent;
        }

        &::after {
          right: 5px;
        }
      }
    }
  }

  &.monthFilter {
    position: absolute;
    right: 24px;
    top: 6px;

    .dropdown {
      .dropdown-menu {
        min-width: 160px;
        border-color: ${(props) => props?.theme?.color?.borderLight};

        .dropdown-item {
          color: ${(props) => props?.theme?.text?.medium};
          font-size: 14px;
          padding: 7px 10px 8px 10px;

          &:hover {
            color: ${(props) => props?.theme?.color?.white};
            background: ${(props) => props?.theme?.green?.dark};
          }

          &:first-child {
            border-radius: 6px 6px 0 0;
          }

          &:last-child {
            border-radius: 0 0 6px 6px;
          }
        }
      }
      .dropdown-toggle {
        color: ${(props) => props?.theme?.green?.dark};
        font-size: 14px;
        font-weight: 600;
        border-color: transparent;
        padding: 10px 25px 10px 15px;

        &:hover {
          border-color: transparent;
        }

        &::after {
          right: 5px;
        }
      }
    }
  }

  &.recordFilter {
    position: absolute;
    right: 24px;
    top: 16px;
    @media (max-width: 567px) {
      position: static;
    }
    .dropdown {
      .dropdown-menu {
        min-width: 160px;
        border-color: ${(props) => props?.theme?.color?.borderLight};

        .dropdown-item {
          color: ${(props) => props?.theme?.text?.medium};
          font-size: 14px;
          padding: 7px 10px 8px 10px;

          &:hover {
            color: ${(props) => props?.theme?.color?.white};
            background: ${(props) => props?.theme?.blue?.dark};
          }

          &:first-child {
            border-radius: 6px 6px 0 0;
          }

          &:last-child {
            border-radius: 0 0 6px 6px;
          }
        }
      }
      .dropdown-toggle {
        color: ${(props) => props?.theme?.blue?.dark};
        font-size: 14px;
        font-weight: 600;
        border-color: transparent;
        padding: 15px 25px 0px 15px;

        &:hover {
          border-color: transparent;
        }

        &::after {
          background: url(${DOWN_ARROW_BLUE.src}) no-repeat 50% 50%;
          right: 5px;
          top: 27px;
        }
      }
    }
  }
  .ic-country {
    width: 40px;
    background-repeat: no-repeat;
    position: relative;
    top: 6px;
  }
  .country-text {
    margin-left: 35px;
    position: relative;
    top: -5px;
  }
  .country-dropdown {
    .dropdown-menu {
      overflow: auto !important;
      height: 300px;
      border-radius: 8px;
      .dropdown-item {
        padding: 12px 24px 12px 24px;
      }
    }

    .dropdown-toggle {
      border: none;
      border-bottom: 1px solid ${(props) => props.theme.color.border};
      box-shadow: none;
      border-radius: 0;
      padding-bottom: 6px;
      padding-top: 8px;
      padding-left: 0px;
    }
  }
  .dob-dropdown {
    .dropdown-menu {
      max-height: 233px;
      overflow: auto;
      .dropdown-item {
        padding: 8px 24px 8px 24px;
      }
    }
    .grey-text {
      color: ${(props) => props.theme.text.medium};
    }
  }
  @media (max-width: 991px) {
    .dropdown-menu {
      .dropdown-menu-item {
        .ic {
          margin-right: 10px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .dropdown {
      .dropdown-toggle {
        .user-name {
          display: none;
        }
      }
    }
  }
  @media (max-width: 480px) {
    &.recordFilter {
      .dropdown-toggle {
        border-radius: 6px;
        background-color: ${(props) => props?.theme?.blue?.iconBg};
        padding: 8px 12px !important;
        color: ${(props) => props?.theme?.blue?.dark} !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        width: 134px;

        &::after {
          position: relative;
          left: 5px;
          top: 3px !important;
          display: inline-block;
          transform: none;
        }
      }
    }

    &.appointmentFilter {
      .dropdown-toggle {
        border-radius: 6px;
        background-color: ${(props) => props?.theme?.blue?.iconBg};
        padding: 8px 12px !important;
        color: ${(props) => props?.theme?.blue?.dark} !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        width: 116px;

        &::after {
          position: relative;
          left: 8px;
          top: 3px !important;
          display: inline-block;
          transform: none;
        }
      }
    }

    &.monthFilter {
      .dropdown-toggle {
        border-radius: 6px;
        background-color: rgba(241, 250, 241, 1);
        padding: 8px 12px !important;
        color: ${(props) => props?.theme?.green?.dark} !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        position: absolute;
        max-width: 50%;
        &::after {
          position: relative;
          left: 5px;
          top: 3px !important;
          display: inline-block;
          transform: none;
          background: url(${IC_DOWN_ARROW_GREEN.src}) no-repeat 50% 50%;
        }
      }
    }

    .dropdown {
      .dropdown-toggle {
        .user-name {
          display: none;
        }
      }

      &.userDropdown {
        width: 34px;
        height: 34px;
        position: absolute;
        top: 0;
        left: 0;

        .btn-primary {
          &:hover {
            background: transparent;
          }
        }

        .dropdown-toggle {
          width: 34px;
          height: 34px;

          &::after {
            opacity: 0;
          }
        }

        .dropdown-menu {
          &:before {
            right: 9px;
          }
          &::after {
            right: 10px;
          }
        }
      }
    }

    .dropdown-menu {
      .dropdown-menu-item {
        .ic {
          margin-right: 10px;
        }
      }
    }
  }
`;

export default DropdownStyled;
